export default {
    state: {
        menuCoor:null, // 右键坐标
        menuShow:false,// 是否显示
        menuhasFeature:false, // 当前位置是否有要素
        menuStart:null , // 菜单上一次点击到位置
        mouseCoor:null, // 当前鼠标位置
    },
    mutations: {
        // 显示右键菜单
        showContextMenu(state, { menuCoor, menuhasFeature,menuStart }) {
            state.menuShow = true
            state.menuCoor = menuCoor;
            state.menuhasFeature = menuhasFeature;
            state.menuStart=menuStart;
        },
        // 隐藏右键菜单
        hideContextMenu(state) {
            state.menuShow = false;
        },
        // 设置鼠标位置
        setMouseCoor(state,coor){
            state.mouseCoor=coor;
        }
    },
}